<template>
  <dropdown
    class="language-select ivu-dropdown--arrow"
    placement="bottom-end"
    trigger="click"
    @on-click="change_language"
  >
    <div class="language-select__title">
      <lang-icon :lang="$i18n.locale" class="language-select__title-icon" />
    </div>
    <dropdown-menu slot="list">
      <template v-for="(lang, index) in list">
        <dropdown-item :key="index" :name="lang.code" class="language-select__item">
          <lang-icon :key="lang.code" :lang="lang.code" class="language-select__item-icon mr-2" />
          {{ lang.title }}
        </dropdown-item>
      </template>
    </dropdown-menu>
  </dropdown>
</template>

<script>
  import LangIcon from '@shared/components/icon/lang/lang-icon';

  export default {
    components: { LangIcon },
    props: {
      list: {
        type: Array,
        default: () => {
          return [
            {
              code: 'en',
              title: 'English'
            },
            {
              code: 'ru',
              title: 'Русский'
            },
            {
              code: 'id',
              title: 'Indonesian'
            }
          ];
        }
      }
    },
    methods: {
      change_language: function (name) {
        this.$emit('change:language', name);
      }
    }
  };
</script>

<style lang="scss">
  .language-select {
    &__title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 70px;
      &:hover {
        cursor: pointer;
      }
    }

    &__title-icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
    &__item {
      height: 44px;
      font-size: 14px !important;
      display: flex;
      align-items: center;

      svg {
        border-radius: 50%;
      }

      &.ivu-dropdown-item {
        font-size: 14px !important;
        padding-right: 16px;
        padding-top: 0;
        padding-bottom: 0;
        color: $blue-grey-light;
      }
    }
    &__item-icon {
      width: 30px;
      height: 30px;
    }
  }
</style>
